<template>
      <div>
        <template v-if="data.state !== null && data.state !== undefined">
            <b-icon v-if="data.state == false" icon="x-octagon" variant="danger" animation="throb" font-scale="8" />
            <b-icon v-if="data.state == true" icon="check" variant="success" animation="throb" font-scale="8" />
         </template>
        <hr>
        <h3 class="mb-0">  {{$t('general.sure')}} </h3>
        <template v-if="data.state !== null && data.state !== undefined">
            <p v-if="data.state == false"> {{data.name}} adlı stoğu pasif etmek istiyor musunuz?</p>
            <p v-if="data.state == true"> {{data.name}} adlı stoğu aktif etmek istiyor musunuz?</p>
        </template>
      
   </div>
</template>

<script>
    export default {
        name: "SetState",
        props:{
            data: Object,
            save: Boolean,
            saveState: Function,
            modalEvent: Function,
            modalName: String,
            sendRequest: Function,
        },
         watch: {
            save: async function(data){
                this.sendRequest()
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/ERP/Stock/modals/SetState.vue